import { green } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import React from "react";
import styles from "./productFlag.scss";

const ProductFlag = (props) => {
  const { productFlags } = props;

  const flagObjs =
    productFlags &&
    productFlags
      .map(
        (flag) =>
          productFlagsData[flag.code] && {
            ...productFlagsData[flag.code],
            name: flag.name,
          }
      )
      .filter(Boolean);

  if (!flagObjs) return null;
  return (
    <div className={styles["product_flags"]}>
      {flagObjs.map((flag, index) => {
        return (
          <div
            className={styles["flag"]}
            style={{ backgroundColor: flag.background_colour }}
            key={`flagObjs_${index}`}
          >
            <span
              className={styles["flag_content"]}
              style={{ color: flag.colour }}
            >
              {flag.name || flag.defaultName}
            </span>
          </div>
        );
      })}
    </div>
  );
};

ProductFlag.defaultProps = {
  product_flags: [],
};

const productFlagsData = {
  NEW: { defaultName: "新品上架", colour: "#546223", background_colour: "#F0FAE5" },
  SOP: { defaultName: "長客計畫", colour: "#38539A", background_colour: "#F1F2FF" },
  SOP_PURCHASE_LIMIT: { defaultName: "限直銷商、會員訂購", colour: "#38539A", background_colour: "#F1F2FF" },
  NEW_MEMBERSHIP: { defaultName: "熱銷夯品", colour: "#FB5480", background_colour: "#FFEBEB", },
  "3E": { defaultName: "安麗購", colour: "#A36A00", background_colour: "#FFFACF" },
  SPECIAL_OFFER: { defaultName: "限時優惠", colour: "#A65523", background_colour: "#FFF1E8", },
};

export { ProductFlag };
